import { eChuongTrinhDaoTaoKienThucActionsObj } from "../../action-types/ctdt/IChuongTrinhDaoTaoKienThucActions";
import { generateActions } from "../generateActions";

export const chuongTrinhDaoTaoKienThucActions = {
  ...generateActions(
    eChuongTrinhDaoTaoKienThucActionsObj,
    "CHUONG_TRINH_DAO_TAO_KIEN_THUC"
  ),
};
